fx.ns("filters", class LayoutCalendarFilter extends fx.Filter {

	constructor(creation)
	{
        super();
        this.creation = creation;
    }

    get area()
    {
        return this._area;
    }

    set area(val)
    {
        this._area = val
        
        this._changed = true;
        this.trigger("updated");
    }

    
	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];

        if (this.area)
        {
            for (let i = 0; i < this.rawData.length; i++)
            {
                let layout = this.rawData.getItemAt(i);
                
                if (layout.target == "back")
                    continue;
                
                if (this.area.data.isCover && layout.target == "cover")
                    this.transformedData.push( layout );
                else
                    if (!this.area.data.isCover && layout.target != "cover")
                    this.transformedData.push( layout );

            }
        }

		return this.transformedData;
	}	

});